<script>
/* eslint-disable new-cap,vue/require-default-prop,vue/require-prop-type-constructor */
import { collectionMethods, clientMethods, serviceMethods, runsheetMethods, instanceExceptionMethods } from '@state/helpers'
import store from '@state/store'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Collections',
    meta: [{ name: 'description', content: 'Collections' }],
  },
  props: {
    service: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      componentKey: 0,
      search: '',
      headers: [
        { text: 'Address', value: 'site.address' },
        { text: 'Suburb', value: 'site.suburb' },
        { text: 'Post Code', value: 'site.postcode' },
        { text: 'Collection Date', value: 'dateSeconds' },
        { text: 'Collection Time', value: 'expected_collection_time' },
        { text: 'Status', value: 'completed' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      completedHeaders: [
        { text: 'Address', value: 'site.address' },
        { text: 'Suburb', value: 'site.suburb' },
        { text: 'Post Code', value: 'site.postcode' },
        { text: 'Collection Date', value: 'dateSeconds' },
        { text: 'Amount Collected', value: 'actual_amount_collected' },
        { text: 'Status', value: 'completed' },
        // { text: 'Actions', value: 'name', sortable: false },
      ],
      incompleteHeaders: [
        // { text: 'Access Time', value: 'expected_collection_time' },
        // { text: 'Client Name', value: 'client_name' },
        { text: 'Address', value: 'address' },
        { text: 'Suburb', value: 'suburb' },
        { text: 'Post Code', value: 'postcode' },
        { text: 'Collection Date', value: 'dateSeconds' },
        { text: 'Note/Photo', value: 'name', sortable: false },
      ],
      serviceHasInit: false,
      collectionsList: [],
      completedList: [],
      upcomingList: [],
      clients:[],
      clientsData:[],
      services:[],
      currentService:[],
      runSheets:[],
      newCollection: {
        client: null,
        client_name: null,
        driver_id: null,
        service_id: null,
        service_title: null,
        expected_collection_time: null,
        created_by: null,
        collection_date: null,
        collection_time: null,
        order: null,
        lat: null,
        lon: null,
        completed: false, // Default value
        processed: false, // Default value
        runSheetId: null,
        site: {},
      },
      dateDialog: false,
      incompleteCollectionsList: [],
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        }
      },
      addCollection: false,
    }
  },
  watch: {
    // Watcher for service as this component is rendering before the parent component
    'service' () {
      this.initService()
    },
  },
  mounted() {
    this.initService();
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    ...collectionMethods, ...clientMethods, ...serviceMethods, ...runsheetMethods, ...instanceExceptionMethods,
    submit() {
      this.$validator.validateAll()
      this.createNewCollection()
    },
    initService () {
      if (this.service && this.service.id) {

        // status default for cant perform collections = 1
        this.getInstanceExceptionsByStatus({status: 1}).then(response => {
          let obj = this.$store.state.instanceExceptions.objects
          let moment = require('moment');
          for (let v in obj) {

            // Only show collections of current client
            let collection = obj[v].collection;
            if( collection && collection.client ){
              if( collection.client.id === this.service.client_id.id ){
                // Create a copy of the object to update it
                let formattedObj = {
                  ...collection
                }

                // Store exception Id
                formattedObj.exceptionId = obj[v].id
                // Convert to Hours
                let serviceTime = collection.expected_collection_time
                let hours = new moment(serviceTime * 1000);
                formattedObj.expected_collection_time = hours.format('H:mm')

                // Convert Date
                formattedObj.collection_date = moment(collection.collection_date).tz('Australia/Sydney').format('DD/MM/YYYY')
                formattedObj.dateSeconds = moment(obj[v].collection_date).valueOf()
                this.incompleteCollectionsList.push(formattedObj)
              }
            }
          }
        })

        let sid = this.service.id
        this.getCollectionsByServiceId({ServiceId: sid}).then(response => {
          let obj = this.$store.state.collections.objects
          let moment = require('moment');
          for (let v in obj) {

            // Create a copy of the object to update it
            let formattedObj = {
              ...obj[v]
            }

            // Convert to Hours
            if (obj[v].expected_collection_time) {
              let serviceTime = obj[v].expected_collection_time
              let hours = new moment(serviceTime * 1000);
              formattedObj.expected_collection_time = hours.format('H:mm')
            }

            // Convert Date
            if (obj[v].collection_date) {
              formattedObj.collection_date = moment(obj[v].collection_date).tz('Australia/Sydney').format('DD/MM/YYYY')
              formattedObj.dateSeconds = moment(obj[v].collection_date).valueOf()
            }

            if (obj[v].completed || obj[v].completed === "Finished") {
              formattedObj.completed = "Finished"
              // console.log(formattedObj)
              // Get bins weight and ADD number for each collection completed
              this.getBinPickupsByCollectionId({colId: parseInt(formattedObj.id)}).then((response) => {

                let binsFormatted = [];

                for(let i in response){

                  let binObj = {
                    key: 0,
                    value: 0,
                    pickup: 0,
                    num: 0,
                  };

                  let num = '';

                  // Build the obj with information returned
                  if (response[i] && response[i].id) {
                    num = parseInt(i);
                    num += 1;

                    binObj.key = parseInt(response[i].id);
                    binObj.value = response[i].weight_collected + ' Kg';
                    binObj.pickup = response[i].pickup_number;
                    binObj.num = num;
                  }
                  binsFormatted.push(binObj);
                }
                formattedObj.binsFormatted = binsFormatted;
                this.completedList.push(formattedObj)
              }).then(() => {
                // If there was no pickup bin information than we need to display based on the actual_amount_collected
                for(let collection in this.completedList){
                  // console.log(this.completedList[collection].binsFormatted.length)
                  if(this.completedList[collection].binsFormatted.length === 0){
                    let binsFormatted = [];

                    // define if the bin is charged per tonne or litre
                    let isChargedPerTonne = true;
                    let isChargedPerLitre = true;
                    let bins = this.completedList[collection].service.service_bins;

                    for(let i in bins){
                      if(bins[i].charge_per_litre){
                        isChargedPerTonne = false;
                        isChargedPerLitre = true;
                      } else if (bins[i].charge_per_tonne){
                        isChargedPerTonne = true;
                        isChargedPerLitre = false;
                      } else {
                        isChargedPerTonne = false;
                        isChargedPerLitre = false;
                      }
                    }

                    for(let i in this.completedList[collection].actual_amount_collected){
                      let binObj = {
                        key: 0,
                        value: 0,
                        pickup: 0,
                        num: 0,
                      };

                      let num = '';
                      num = parseInt(i);
                      num += 1;

                      // Define if Litre or Tonne
                      let tonne = isChargedPerTonne ? ' Tonne' : '';
                      let litre = isChargedPerLitre ? ' Litres' : '';

                      binObj.key = parseInt(i);
                      binObj.value = tonne ? this.completedList[collection].actual_amount_collected[i] + tonne : this.completedList[collection].actual_amount_collected[i] + litre;
                      binObj.num = num;
                      binsFormatted.push(binObj);
                    }


                    this.completedList[collection].binsFormatted = binsFormatted;
                  }
                }
                this.serviceHasInit = true;

                // Trick to rerender the component
                this.componentKey += 1;
              })
            } else if (!obj[v].completed || obj[v].completed === "In Progress") {
              formattedObj.completed = "In Progress"
              let moment = require('moment');
              let today = moment().format("YYYY-MM-DD")
              let collection = moment(obj[v].collection_date, "YYYY-MM-DD")

              if(collection.isAfter(today)){
                this.upcomingList.push(formattedObj)
              }
            }
            this.collectionsList.push(formattedObj)
          }
        })

        if(this.service.client_id) {
          this.newCollection.client_name = this.service.client_id.client_name
        }
        this.newCollection.service = this.service.service_title
        if(this.service.site) {
          this.newCollection.site.trading_name = this.service.site.trading_name
          this.newCollection.site.address = this.service.site.address
          this.newCollection.site.postcode = this.service.site.postcode
          this.newCollection.site.suburb = this.service.site.suburb
          this.newCollection.site.mobile = this.service.site.mobile
          this.newCollection.site.phone = this.service.site.phone
        }
      }
    },
    computedDateFormattedMomentjs () {
      // @TODO check why its complaining when convert date
      // let moment = require('moment');
      // this.newCollection.collection_date = moment(this.newCollection.collection_date).format('DD/MM/YYYY')
    },
    async createNewCollection(){
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let userId = store.getters['auth/getUserId'];

          let serviceId = this.service.id
          let expectedCollectionTime = this.newCollection.expected_collection_time
          let createdBy = userId
          let collectionDate = this.newCollection.collection_date
          let collectionTime = this.newCollection.expected_collection_time
          let order = this.newCollection.order
          let completed = this.newCollection.completed
          let processed = this.newCollection.processed
          let runsheetId = this.newCollection.runSheetId

          // Get bins IDs from the items selected
          let binsIds = [];
          for(let i in this.binsToCollect){
            if(this.binsToCollect[i] && this.binsToCollect[i].id)
              binsIds.push(parseInt(this.binsToCollect[i].id))
          }

          this.createCollection({
            service_id: parseInt(serviceId),
            expected_collection_time: expectedCollectionTime,
            created_by: createdBy,
            collection_date: collectionDate,
            collection_time: collectionTime,
            order: order,
            completed: completed,
            processed: processed,
            runsheetId: runsheetId,
            bins: binsIds
          })
            .then(d => {
              location.reload()
            })
        }
      })
    },
    clear() {
      this.newCollection = {}
      this.$validator.reset()
      this.addCollection = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    async getRunSheets(date){
      await this.getRunsheetsByDate({date: date}).then(response => {
        this.runSheets = response;
        // console.log(response)
      })
    },
    onDateChange(date){
      // Convert Date format
      this.computedDateFormattedMomentjs()
      this.dateDialog = false;
      this.getRunSheets(date);
    },
    onRunSheetSelected(id){
      // Determine the collection order
      for(let i in this.runSheets){
        if (this.runSheets[i].id === id){
          // Get last collection position
          if(this.runSheets[i].collections.length > 0 ){
            this.newCollection.order = this.runSheets[i].collections.length;
          } else {
            // Otherwise will be first collection order
            this.newCollection.order = 1;
          }
        }
      }
    }
  },
}
</script>

<template>
  <div>
    <div class="">
      <h2 :class="$style.routeHeader">
        Collections
      </h2>
    </div>
    <!--<VBtn-->
    <!--slot="activator"-->
    <!--:class="$style.addButton"-->
    <!--color="blue"-->
    <!--@click="addCollection = !addCollection"-->
    <!--&gt;-->
    <!--+ ADD COLLECTION-->
    <!--</VBtn>-->
    <VLayout style="width: 100%">

      <VFlex
        xs0
        sm12
      />
      <VFlex
        xs12
        md5
      >
        <VTextField
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        />
      </VFlex>
    </VLayout>
    <h3>Upcoming:</h3>
    <VDataTable
      :headers="headers"
      :items="upcomingList"
      :search="search"
      rows-per-page-text=""
      :rows-per-page-items="[10]"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.client.id }}-->
        <!--</td>-->
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.client.client_name }}-->
        <!--</td>-->
        <td class="text-xs-left">
          {{ props.item.site.address }}
        </td>
        <td class="text-xs-left">
          {{ props.item.site.suburb }}
        </td>
        <td class="text-xs-left">
          {{ props.item.site.postcode }}
        </td>
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.site.phone }}-->
        <!--</td>-->
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.site.mobile }}-->
        <!--</td>-->
        <td class="text-xs-left">
          {{ props.item.collection_date }}
        </td>
        <td class="text-xs-left">
          {{ props.item.expected_collection_time }}
        </td>
        <td class="text-xs-left">
          {{ props.item.completed }}
        </td>

        <td class="justify-center px-0">
          <VBtn
            slot="activator"
            style="display: block; position:relative; margin: 0 auto"
            color="blue"
            @click.native="changeRoute({name: 'view-collection', params: {id: props.item.id}})"
          >
            View
          </VBtn>
        </td>
      </template>
      <VAlert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >
        Your search for "{{ search }}" found no results.
      </VAlert>
    </VDataTable>
    <br>
    <h3>Completed:</h3>
    <VDataTable
      :key="componentKey"
      :headers="completedHeaders"
      :items="completedList"
      :search="search"
      rows-per-page-text=""
      :rows-per-page-items="[10]"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.client.client_name }}-->
        <!--</td>-->
        <td class="text-xs-left">
          {{ props.item.site.address }}
        </td>
        <td class="text-xs-left">
          {{ props.item.site.suburb }}
        </td>
        <td class="text-xs-left">
          {{ props.item.site.postcode }}
        </td>
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.site.phone }}-->
        <!--</td>-->
        <!--<td class="text-xs-left">-->
        <!--{{ props.item.site.mobile }}-->
        <!--</td>-->
        <td class="text-xs-left">
          {{ props.item.collection_date }}
        </td>
        <td
          class="text-xs-left"
        >
          <div class="scrollable">
            <ul
              v-for="n in props.item.binsFormatted"
              :key="n.key"
            >
              <li>Bin {{ n.num }} (ADD: {{ n.pickup }}) = {{ n.value }}</li>
            </ul>
          </div>
        </td>
        <td class="text-xs-left">
          {{ props.item.completed }}
        </td>
      </template>
      <VAlert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >
        Your search for "{{ search }}" found no results.
      </VAlert>
    </VDataTable>

    <br>

    <div v-if="incompleteCollectionsList">
      <h3>Incomplete Collections History:</h3>
      <VDataTable
        :headers="incompleteHeaders"
        :items="incompleteCollectionsList"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <!--<td class="text-xs-left">-->
          <!--{{ props.item.expected_collection_time }}-->
          <!--</td>-->
          <!--<td class="text-xs-left">-->
          <!--{{ props.item.client.client_name }}-->
          <!--</td>-->
          <td class="text-xs-left">
            {{ props.item.site.address }}
          </td>
          <td class="text-xs-left">
            {{ props.item.site.suburb }}
          </td>
          <td class="text-xs-left">
            {{ props.item.site.postcode }}
          </td>
          <td class="text-xs-left">
            {{ props.item.collection_date }}
          </td>

          <td class="justify-center px-0">
            <VBtn
              slot="activator"
              style="display: block; position:relative; margin: 0 auto"
              color="blue"
              @click.native="changeRoute({name: 'view-collection-notes-photos', params: {id: props.item.id}})"
            >
              View Note/Photo
            </VBtn>
          </td>
        </template>
        <VAlert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >
          Your search for "{{ search }}" found no results.
        </VAlert>
      </VDataTable>
    </div>


    <!-- ADD COLLECTION MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addCollection"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>New Collection</h2>
              <VLayout wrap>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.client_name"
                    label="Client Name"
                    required
                    readonly
                  />

                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.service"
                    label="Service"
                    required
                    readonly
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.trading_name"
                    label="Trading Name"
                    required
                    readonly
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.address"
                    label="Address"
                    required
                    readonly
                  />
                </VFlex>

                <VLayout wrap>
                  <VFlex xs3>
                    <VTextField
                      v-model="newCollection.site.postcode"
                      label="Post Code"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs9>
                    <VTextField
                      v-model="newCollection.site.suburb"
                      label="Suburb"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.mobile"
                      label="Mobile"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.phone"
                      label="Phone"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VDialog
                      v-model="dateDialog"
                      persistent
                      width="290px"
                    >
                      <VTextField
                        slot="activator"
                        v-model="newCollection.collection_date"
                        v-validate="'required'"
                        :error-messages="errors.collect('collection_date')"
                        data-vv-name="collection_date"
                        label="Date"
                        append-icon="event"
                        readonly
                      />
                      <VDatePicker
                        v-model="newCollection.collection_date"
                        header-color="#00baff"
                        color="#00baff"
                        scrollable
                        @input="onDateChange(newCollection.collection_date)"
                      />
                    </VDialog>
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.expected_collection_time"
                      label="Access Time"
                      required
                    />
                  </VFlex>
                </VLayout>
                <VFlex xs12>
                  <VSelect
                    v-model="newCollection.runSheetId"
                    v-validate="'required'"
                    :error-messages="errors.collect('run_sheet')"
                    data-vv-name="run_sheet"
                    :items="runSheets"
                    item-text="vehicle.number_plate"
                    item-value="id"
                    label="Run Sheet"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @input="onRunSheetSelected(newCollection.runSheetId)"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addCollection = false"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="createNewCollection()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </div>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }

</style>
